import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import ActionButton from "@/components/base/ActionButton";

const fleetTargets = [
  "Logistics",
  "Delivery",
  "Passenger Mobility",
  "Commercial Fleets",
  "Institutional Vehicles",
  "Small Business Fleets",
  "Specialised Applications",
];

export default function FleetSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div className="overflow-hidden rounded-lg border border-background-200">
              <div className="h-64 w-full md:h-[420px]">
                <img
                  src="https://readdy.ai/api/search-image?query=row%20of%20clean%20commercial%20vehicles%20parked%20in%20a%20modern%20depot%20with%20EV%20charging%20posts%2C%20graphite%20and%20green%20tones%2C%20premium%20industrial%20photography%2C%20soft%20overcast%20light&width=1400&height=900&seq=klz-fleet-01&orientation=landscape"
                  alt="Commercial fleet vehicles at a depot with EV charging infrastructure"
                  title="Fleet electrification with EV retrofit"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <SectionHeading
              eyebrow="Fleet Electrification"
              title="Electrify Your Fleet Without Replacing Everything."
              description="Fleet electrification does not have to mean replacing every vehicle at once. A phased retrofit plan lets an organisation assess vehicles, prioritise the right candidates and plan charging alongside the vehicles."
            />
            <ul className="mt-8 flex flex-wrap gap-2.5">
              {fleetTargets.map((target) => (
                <li
                  key={target}
                  className="rounded-full border border-background-300 bg-background-100 px-3.5 py-1.5 font-label text-xs font-medium text-foreground-800"
                >
                  {target}
                </li>
              ))}
            </ul>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <ActionButton to="/fleet" variant="primary" size="lg" icon="ri-roadster-line">
                Request Fleet Assessment
              </ActionButton>
              <ActionButton to="/solutions" variant="outline" size="lg">
                Fleet Solutions
              </ActionButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}